import styled from "styled-components";

export const CardGridContainer = styled.div`
  width: ${(props) => props.innerWidth};
  /* width: 85%; */
  margin: 0 auto;
  /* display: flex; */
  /* justify-content: center; */
  /* z-index: -200; */
`;
